import {
  ADD_LOCATION,
  ADD_LOCATION_FAILURE,
  ADD_LOCATION_SUCCESS,
  DELETE_LOCATION,
  DELETE_LOCATION_FAILURE,
  DELETE_LOCATION_SUCCESS,
  EDIT_LOCATION,
  EDIT_LOCATION_FAILURE,
  EDIT_LOCATION_SUCCESS,
  FETCH_LOCATIONS,
  FETCH_LOCATIONS_FAILURE,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_DRAWERS,
  FETCH_DRAWERS_FAILURE,
  FETCH_DRAWERS_SUCCESS,
} from './actions';
import { VIRTUAL_TERMINAL } from './type';

export const INITIAL_STATE: VIRTUAL_TERMINAL.VirtualTerminalReducer = {
  isLoading: 0,
  error: {} as VIRTUAL_TERMINAL.IError,
  locationsList: [],
  drawersList: [],
  locationUpdated: false,
};

const paymentConfigReducer = (
  action: IAction,
  state = INITIAL_STATE
): VIRTUAL_TERMINAL.VirtualTerminalReducer => {
  switch (action.type) {
    case FETCH_LOCATIONS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {} as VIRTUAL_TERMINAL.IError,
      };
    case FETCH_LOCATIONS_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {} as VIRTUAL_TERMINAL.IError,
        locationsList: action.payload.data,
      };
    case FETCH_LOCATIONS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { ...state.error, fetchLocationsList: action.payload.message },
      };
    case ADD_LOCATION:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        locationUpdated: false,
        error: {} as VIRTUAL_TERMINAL.IError,
      };
    case ADD_LOCATION_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        locationUpdated: true,
        error: {} as VIRTUAL_TERMINAL.IError,
      };
    case ADD_LOCATION_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        locationUpdated: false,
        error: { ...state.error, addLocation: action.payload.message },
      };
    case EDIT_LOCATION:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        locationUpdated: false,
        error: {} as VIRTUAL_TERMINAL.IError,
      };
    case EDIT_LOCATION_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        locationUpdated: true,
        error: {} as VIRTUAL_TERMINAL.IError,
      };
    case EDIT_LOCATION_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        locationUpdated: false,
        error: { ...state.error, editLocation: action.payload.message },
      };
    case DELETE_LOCATION:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        locationUpdated: false,
        error: {} as VIRTUAL_TERMINAL.IError,
      };
    case DELETE_LOCATION_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        locationUpdated: true,
        error: {} as VIRTUAL_TERMINAL.IError,
      };
    case DELETE_LOCATION_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        locationUpdated: false,
        error: { ...state.error, deleteLocation: action.payload.message },
      };
    case FETCH_DRAWERS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {} as VIRTUAL_TERMINAL.IError,
      };
    case FETCH_DRAWERS_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {} as VIRTUAL_TERMINAL.IError,
        drawersList: action.payload.data,
      };
    case FETCH_DRAWERS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        drawersList: [],
        error: { ...state.error, fetchDrawersList: action.payload.message },
      };
    default:
      return state;
  }
};
export default paymentConfigReducer;
